<template>
  <div>
    <h5>Facility Details & Map</h5>
    <div id="info-facility-details-map">
      <iframe
        class="w-full md:w-1/2"
        :src="`https://maps-api-ssl.google.com/maps?q=${facility.address1}+${facility.city}%2c+${facility.state}+${facility.zip}&f=q&source=s_q&hl=en&output=embed`"
      />
    </div>
    <div
      id="info-facility-details-desc"
      class="p-2"
    >
      <p class="facility-name font-bold">
        {{ facility.name }}
      </p>
      <p class="facility-address-full">
        {{ facility.address1 }}, {{ facility.city }}, {{ facility.state }}, {{ facility.zip }}
      </p>
      <p class="session-date">
        {{ timeStampStart }} - {{ timeStampEnd }} {{ workshopTimezone }}
      </p>
      <p v-if="facility.phone">
        Front Desk Phone: {{ facility.phone }}
      </p>
      <p class="parkingnote">
        There may be a fee for parking on-property at this facility. Summit does not reimburse for venue parking fees. Alternative free and paid parking options may be
        available, please contact the venue for details.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapDetails',
  props: {
    facility: {
      type: Object,
      required: true,
    },
    timeStampStart: {
      type: String,
      required: true,
    },
    timeStampEnd: {
      type: String,
      required: true,
    },
    workshopTimezone: {
      type: String,
      required: true,
    },
  },
  methods: {

  },
};
</script>
